import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import { formatDateFromISO } from '@tenant/utility/helper/DateHelper';
import { inputFormatDateTime } from '@tenant/utility/constants/default';
import AppLoader from '@tenant/core/AppLoader';
import AppJLEmptyResult from '@tenant/core/AppList/AppJLEmptyResult';

function formatNewlinesForHTML(input) {
  return input.replace(/\n/g, '<br>');
}

const LogList = ({ data = [], loading = false }) => {
  return (
    <Box
      sx={{
        '& .MuiAccordion-root': {
          boxShadow: 'none',
          backgroundColor: grey[50],
        },
      }}
    >
      {loading && <AppLoader />}
      {!loading && data.length === 0 && <AppJLEmptyResult />}
      {data.map((data, i) => (
        <Accordion key={data.CreatedDate + i} defaultExpanded={i === 0}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: 'flex', gap: 2, flexWreap: 'wrap' }}>
              <Typography sx={{ color: 'text.secondary', whiteSpace: 'pre' }}>
                {formatDateFromISO(data.CreatedDate, inputFormatDateTime)}
              </Typography>
              <Typography sx={{ maxWidth: '400px', color: 'text.secondary', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {data.AppLog}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography fontSize={13} dangerouslySetInnerHTML={{ __html: formatNewlinesForHTML(data.AppLog) }} />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default React.memo(LogList);

LogList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
};
